import type { Ref } from "react";

import { componentManager, rwc } from "@frontend/bridge/ComponentManager";
import { useIslandHost } from "@frontend/contexts";

import {
  ContactAddressModal,
  type ContactAddressModalHandle,
} from "./ContactAddressModal";
import {
  type ContactAddressModalDataProps,
  contactAddressModalDataSchema,
} from "./ContactAddressModal.schema";
import type { LocationAddressDetail, LocationTypedAddress } from "./types";

declare module "@frontend/bridge/types" {
  interface ComponentRegistryMap {
    "contact-address-modal": {
      props: ContactAddressModalDataProps;
      handle: ContactAddressModalHandle;
    };
  }
}

declare global {
  interface HTMLElementTagNameMap {
    "rwc-contact-address-modal": HTMLElement & ContactAddressModalHandle;
  }
}

export function RWCContactAddressModal({
  ref,
}: ContactAddressModalDataProps & {
  ref?: Ref<ContactAddressModalHandle>;
}) {
  const host = useIslandHost();

  const handleSubmit = (
    address: LocationTypedAddress | LocationAddressDetail,
  ) => {
    host?.dispatchEvent(
      new CustomEvent("modal:submit", {
        detail: { address },
        bubbles: true,
      }),
    );
  };

  return <ContactAddressModal ref={ref} onSubmit={handleSubmit} />;
}

componentManager.register(
  rwc("contact-address-modal", {
    component: RWCContactAddressModal,
    dataSchema: contactAddressModalDataSchema,
  }),
);
